export default {
  create: {
    method: 'post',
    url: '/partner/task-completion-time/cooperatorId'
  },
  getById: {
    method: 'get',
    url: '/partner/task-completion-time/cooperatorId/ID'
  },
  edit: {
    method: 'put',
    url: '/partner/task-completion-time/cooperatorId/ID'
  },
  delete: {
    method: 'delete',
    url: '/partner/task-completion-time/cooperatorId'
  },
  archive: {
    method: 'delete',
    url: '/partner/task-completion-time/archive'
  },
  restore: {
    method: 'put',
    url: '/partner/task-completion-time/restore'
  }
}
